export const LISTING_PRODUCT_BULK_ACTION_PLATFORMS = [
  'KOGAN',
  'KOGANNZD',
  'TIKTOK',
  'WALMART',
  'EBAY',
  'SHEIN',
  'TEMU',
] as const

export const LISTING_PRODUCT_DELIST_ONLY_PLATFORMS = ['TIKTOK', 'WALMART'] as const

export const LISTING_PRODUCT_DELIST_RELIST_PLATFORMS = ['EBAY', 'SHEIN', 'TEMU'] as const

export type ListingProductBulkActionOption = {
  value: string
  label: string
  requiresSelection?: boolean
}

export const isListingProductBulkActionPlatform = (platformName?: string | null): boolean =>
  LISTING_PRODUCT_BULK_ACTION_PLATFORMS.includes(
    `${platformName ?? ''}`.toUpperCase() as (typeof LISTING_PRODUCT_BULK_ACTION_PLATFORMS)[number]
  )

export const getListingProductBulkActionOptions = (
  platformName?: string | null
): ListingProductBulkActionOption[] => {
  const normalized = `${platformName ?? ''}`.toUpperCase()
  if (
    LISTING_PRODUCT_DELIST_ONLY_PLATFORMS.includes(
      normalized as (typeof LISTING_PRODUCT_DELIST_ONLY_PLATFORMS)[number]
    )
  ) {
    return [{ value: 'delist', label: 'Delist', requiresSelection: true }]
  }

  if (
    LISTING_PRODUCT_DELIST_RELIST_PLATFORMS.includes(
      normalized as (typeof LISTING_PRODUCT_DELIST_RELIST_PLATFORMS)[number]
    )
  ) {
    return [
      { value: 'delist', label: 'Delist', requiresSelection: true },
      { value: 'relist', label: 'Relist', requiresSelection: true },
    ]
  }

  return [
    { value: 'delist', label: 'Delist', requiresSelection: true },
    { value: 'relist', label: 'Relist', requiresSelection: true },
    { value: 'full_update', label: 'Full Update' },
  ]
}
